import { CheckCircle } from "@phosphor-icons/react";
import clsx from "clsx";

import { CARD_ICONS, PAYMENT_METHODS } from "common/constants";
import type { PaymentSource } from "common/types";

interface PaymentSourceProps {
  paymentSource: PaymentSource;
  selectedMethod: PaymentSource;
  setSelectedMethod: (paymentSource: PaymentSource) => void;
}

export default function PaymentSourceOption({
  paymentSource,
  selectedMethod,
  setSelectedMethod,
}: PaymentSourceProps) {
  const { type, id } = paymentSource;

  // Get the icon for the payment method
  const Icon =
    type === "card"
      ? CARD_ICONS[paymentSource.card.brand]
      : PAYMENT_METHODS[type].icon;

  const isSelected = selectedMethod?.id === id;

  return (
    <button
      className={clsx(
        "flex items-center gap-2 rounded-3xl px-2 py-2.5 transition-colors",
        isSelected
          ? "bg-purple-50 outline-purple-200 outline-2 outline"
          : "bg-black-100",
      )}
      onClick={() => setSelectedMethod(paymentSource)}
      type="button"
    >
      <Icon />

      <span className="text-sm-bold">
        {type === "card"
          ? `Card ending with ${paymentSource.card.last4}`
          : paymentSource.paypal.email}
      </span>

      {isSelected && (
        <CheckCircle className="ml-auto size-6 text-purple-600" weight="fill" />
      )}
    </button>
  );
}
